import React, { type ReactElement } from 'react';
import { useFormContext } from 'react-hook-form';
import AppliedFilters from 'atom-components/applied-filters-lite';
import Checkbox from 'atom-components/form-fields-for-hook-form/checkbox';
import { filterFormDefaultValues } from './filter-form.schema';

const fieldLabel = 'Allocated to me only';
const fieldName = 'allocatedToMeOnly';

type Props = {
  triggerFormSubmission: () => void;
};

export default function AllocatedToMeOnlyFilter({ triggerFormSubmission }: Props): ReactElement {
  const { control } = useFormContext();

  return (
    <Checkbox role="switch">
      <Checkbox.Input
        id={fieldName}
        control={control}
        name={fieldName}
        role="switch"
        onChange={(): void => triggerFormSubmission()}
      />
      <Checkbox.Label htmlFor={fieldName}>{fieldLabel}</Checkbox.Label>
    </Checkbox>
  );
}

export function AllocatedToMeOnlyAppliedFilter({
  triggerFormSubmission
}: Props): ReactElement | null {
  const { watch, resetField } = useFormContext();
  const allocatedToMeOnly = watch(fieldName);

  if (!allocatedToMeOnly) return null;

  return (
    <AppliedFilters.Filter name={fieldLabel}>
      <AppliedFilters.FilterItem
        onClick={(): void => {
          // There is an issue/feature of React Hook Form where the field is reset from
          // defaultValuesFromURLParams, the last reset of the form, rather than the form's
          // defaultValues if an explicit defaultValue is not passed to resetField. This applies
          // to other cases where resetField is used as well.
          resetField(fieldName, { defaultValue: filterFormDefaultValues.allocatedToMeOnly });
          triggerFormSubmission();
        }}
      >
        {allocatedToMeOnly && 'Yes'}
      </AppliedFilters.FilterItem>
    </AppliedFilters.Filter>
  );
}
